import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { MyDatePickerModule } from "@intocare/ui-my-date-picker";
import { MyDateRangePickerModule } from "@intocare/ui-my-date-range-picker";

import { DateFilterComponent } from "./date-filter.component";
import { ButtonModule } from "../button/button.module";

@NgModule({
	imports: [CommonModule, ButtonModule, TranslateModule, MyDatePickerModule, MyDateRangePickerModule],
	declarations: [DateFilterComponent],
	exports: [DateFilterComponent],
})
export class DateFilterModule {}
